import { defineStore } from "pinia";
import { ref, type Ref } from "vue";
import type { ApiResponse, PaginatedResponse, Pagination } from "@/app/types";
import api from "@/app/services/apiNir.ts";
import type { AxiosResponse } from "axios";
import { Institution, InstitutionType } from "@/domains/home/services/nir/associate-registers/types";

export const useInstitutionStore = defineStore("institutions", () => {
  const okResponse:Ref<object|undefined> = ref()
  const pagination:Ref<Pagination|undefined> = ref()
  const institutions:Ref<Institution[]|undefined> = ref()
  const institution:Ref<Institution|undefined> = ref()
  const institutionTypes:Ref<InstitutionType[]|undefined> = ref()

  const createInstitution = async (payload:object) => {
    return api.post("/v1/institutions", payload)
      .then((response: AxiosResponse<ApiResponse<object>>) => {
        okResponse.value = response.data.data
      })
  }

  const fetchInstitutions = async (page:number, limit:number) => {
    let path = `/v1/institutions?page=${page}&limit=${limit}`
    return api.get(path)
      .then((response: AxiosResponse<ApiResponse<PaginatedResponse<Institution>>>) => {
        institutions.value = response.data.data.content
        pagination.value = response.data.data.pagination
      })
  }

  const fetchInstitution = async (id:string) => {
    let path = `/v1/institutions/entity?id=${id}`
    return api.get(path)
        .then((response: AxiosResponse<ApiResponse<Institution>>) => {
          institution.value = response.data.data
        })
  }

  const approveInstitution = async (payload:object) => {
    return api.put(`/v1/institutions/approve`, payload)
        .then((response: AxiosResponse<ApiResponse<Institution>>) => {
          institution.value = response.data.data
        })
  }

  const rejectInstitution = async (id:string) => {
    return api.get(`/v1/institutions/${id}/reject`)
        .then((response: AxiosResponse<ApiResponse<Institution>>) => {
          institution.value = response.data.data
        })
  }

  const setInstitutionType = async (payload:object) => {
    return api.put(`/v1/institutions/add-type`, payload)
        .then((response: AxiosResponse<ApiResponse<object>>) => {
          okResponse.value = response.data.data
        })
  }

  const removeInstitutionType = async (payload:object) => {
    return api.put(`/v1/institutions/remove-type`, payload)
        .then((response: AxiosResponse<ApiResponse<object>>) => {
          okResponse.value = response.data.data
        })
  }

    const enableDirectAdmission = async (payload:object) => {
        return api.put(`/v1/institutions/direct-admission/enable`, payload)
            .then((response: AxiosResponse<ApiResponse<object>>) => {
                okResponse.value = response.data.data
            })
    }

    const disableDirectAdmission = async (payload:object) => {
        return api.put(`/v1/institutions/direct-admission/disable`, payload)
          .then((response: AxiosResponse<ApiResponse<object>>) => {
            okResponse.value = response.data.data;
          })
    }

  const enableInterimErn = async (payload: object) => {
    return api.put(`/v1/institutions/interim-ern/enable`, payload)
      .then((response: AxiosResponse<ApiResponse<object>>) => {
        okResponse.value = response.data.data;
      });
  };

  const disableInterimErn = async (payload: object) => {
    return api.put(`/v1/institutions/interim-ern/disable`, payload)
            .then((response: AxiosResponse<ApiResponse<object>>) => {
                okResponse.value = response.data.data
            })
    }

    const enableRegisterExisting = async (payload: object) => {
        return api.put(`/v1/institutions/register-existing/enable`, payload)
            .then((response: AxiosResponse<ApiResponse<object>>) => {
                okResponse.value = response.data.data;
            });
    };

    const disableRegisterExisting = async (payload: object) => {
        return api.put(`/v1/institutions/register-existing/disable`, payload)
            .then((response: AxiosResponse<ApiResponse<object>>) => {
                okResponse.value = response.data.data
            })
    }

  return{
    okResponse,
    institutions,
    institution,
    institutionTypes,
    pagination,
    createInstitution,
    fetchInstitutions,
    fetchInstitution,
    approveInstitution,
    rejectInstitution,
    setInstitutionType,
    removeInstitutionType,
    enableDirectAdmission,
    disableDirectAdmission,
    enableInterimErn,
    disableInterimErn,
      enableRegisterExisting,
      disableRegisterExisting
  }
})